import { PropsWithChildren, useState } from "react";
import { selectedTeamCtx } from "../contexts/selectedTeam";
import { Team } from "../types";

export const SelectedTeamProvider = ({ children }: PropsWithChildren) => {
  const [selectedTeam, setSelectedTeam] = useState<Team | null>(null);

  return (
    <selectedTeamCtx.Provider value={{ selectedTeam, setSelectedTeam }}>
      {children}
    </selectedTeamCtx.Provider>
  );
};


